import { Row } from "@/common/custom-lists/ListView";
import { connect } from "react-redux";
import Select from "react-select";

const ReportsBulkClientsRow = ({ organisation, reportPackOptions, appliedReportPacks, updateApplied }) => {
	return (
		<Row
			actionColumns={[0]}
			columns={[
				" ",
				organisation?.name,
				<div>
					<Select
						value={appliedReportPacks.map((reportPack) => ({
							value: reportPack.id,
							label: reportPack.name,
						}))}
						options={reportPackOptions}
						isMulti
						onChange={(e) => {
							updateApplied(e);
						}}
					/>
				</div>,
				" ",
			]}
		/>
	);
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ReportsBulkClientsRow);
